var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.88672C3.49823 6.60347 3.57366 6.32489 3.71777 6.08105L3.71875 6.07812C3.86177 5.8325 4.06624 5.6279 4.31152 5.48438L9.73926 2.38281C9.99038 2.24191 10.2735 2.16797 10.5615 2.16797C10.8495 2.16797 11.1327 2.24192 11.3838 2.38281L16.8076 5.48145V5.48242C16.9927 5.59064 17.1549 5.73277 17.2852 5.90137L17.4043 6.0791C17.5109 6.26442 17.5801 6.46813 17.6084 6.67871L17.623 6.8916V13.0967L17.6084 13.3115C17.5801 13.5246 17.5103 13.7306 17.4023 13.918V13.9199C17.2618 14.1657 17.0573 14.3692 16.8115 14.5098L11.3809 17.6133L11.3779 17.6152C11.13 17.7591 10.8481 17.835 10.5615 17.835C10.2749 17.835 9.99301 17.7591 9.74512 17.6152L9.74316 17.6133L4.31152 14.5098C4.06495 14.3661 3.86014 14.1604 3.71777 13.9131C3.57502 13.665 3.49992 13.3839 3.5 13.0977V6.88672Z",
    fill: "#FA532E",
    stroke: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicOrange);
export default __webpack_public_path__ + "static/media/basic-orange.749a01ffda5852eebf2d7c47b21a0726.svg";
export { ForwardRef as ReactComponent };